import { Link } from 'react-router-dom';
import { KSIEGOWOSC_AI_PATH } from '@bookkeeper/shared/ksiegowosc-ai';
import { useTranslation } from '@/i18n/i18n';

/**
 * Links to /ksiegowosc-ai (INTERNAL-LINKS.md, table B): one link per page in the body, a different
 * anchor on each page. The target is Polish-only, so the English and Ukrainian pages never link to
 * it as if it were their equivalent.
 */

export function AiAccountingLink({ anchor, className }: { anchor: string; className?: string }) {
  const { locale } = useTranslation();
  if (locale !== 'pl') return null;
  return (
    <Link
      to={KSIEGOWOSC_AI_PATH}
      className={className ?? 'underline underline-offset-4 hover:no-underline'}
    >
      {anchor}
    </Link>
  );
}
